<template>
  <div class="page-productDetails">
    <Header :callback="getUserInfo" :showBack="true" :show-language="true" />
    <div class="dialog" v-show="dialogStartShow">
      <div class="dialog-content">
        <div class="my-score">
          <h3 class="my-score-title">我要点评</h3>
          <div class="score-group">
            <div class="score-item">
              <p class="score-title">质量稳定</p>
              <div class="score-box">
                <div class="scores">
                  <img
                    :src="`${rateOneNum > index ? require('../../assets/images/start_big_active.png') : require('../../assets/images/start_big.png')}`"
                    alt="" class="score-img" v-for="(item, index) in 5" @click="changeStart('one', index)" />
                </div>
                <span class="num">{{ (rateOneNum * 2).toFixed(1) }}</span>
              </div>
            </div>
            <div class="score-item">
              <p class="score-title">技术创新</p>
              <div class="score-box">
                <div class="scores">
                  <img
                    :src="`${rateTwoNum > index ? require('../../assets/images/start_big_active.png') : require('../../assets/images/start_big.png')}`"
                    alt="" class="score-img" v-for="(item, index) in 5" @click="changeStart('two', index)" />
                </div>
                <span class="num">{{ (rateTwoNum * 2).toFixed(1) }}</span>
              </div>
            </div>
            <button class="score-submit" @click="submitStart()">提交</button>
          </div>
        </div>
        <span class="dialog-close" @click="dialogStartShow = false"></span>
      </div>
    </div>
    <div class="dialog comment" v-show="dialogCommentShow">
      <div class="dialog-content">
        <div class="supply-comment">
          <div class="comment-head">
            <span class="left" @click="removeReply()">取消</span>
            <span class="title">{{ replyType === 1 ? '回复互动' : '发布互动' }}</span>
            <button class="right" @click="submitReply()">{{ replyType === 1 ? '回复' : '发布' }}</button>
          </div>
          <div class="comment-content">
            <textarea maxlength="1000" :placeholder="`${replyType === 1 ? '回复互动...' : '发布互动...'}`" v-model="suplyText"
              @input="changeText($event)"></textarea>
            <p class="max-length"><span>{{ suplyTextLength }}</span>/1000</p>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div class="product-edit-btns" v-if="userInfo && this.status != '0' && this.status != '2'">
        <p @click="editAction">
          <img src="../../assets/images/icon-edit.png"> 编辑
        </p>
        <p @click="favAction">
          <img src="../../assets/images/icon-fav.png"> {{ detailsData.ollect_type === 2 ? '已收藏' : '收藏' }}
        </p>
        <p @click="rlAction" v-if="detailsData.claimant == 0">
          <img src="../../assets/images/icon-rl.png"> 认领
        </p>
      </div>
      <div class="top-base">
        <div class="info-content">
          <h2 class="top-title">
            <span v-html="detailsData.shop_product_name"></span>
            <img v-if="detailsData.activity_tag == 1" class="icon-join" src="../../assets/images/icon-join.png" alt="">
            <img v-if="detailsData.claimant" class="icon-join" src="../../assets/images/icon-rl-success.png" alt="">
          </h2>
          <p class="subtitle">技术数据表由<router-link :to="`/companyDetails?companyId=${this.companyId}`" class="company">{{
            detailsData.munufacturer_abbreviation }}</router-link><i class="company-icon"
              v-show="showCompanyIcon"></i>提供并授权发布</p>
          <p class="cas" v-if="detailsData.cas_number != ''">CAS: <span v-html="detailsData.cas_number"></span></p>
          <p class="info" v-if="detailsData.trademark != '' || detailsData.grade != ''">
            <span class="label" v-if="detailsData.trademark != ''">商标</span>
            <span class="text" v-if="detailsData.trademark != ''">{{ detailsData.trademark }}</span>
          </p>
        </div>
        <div class="get-invoice" @click="setDialogInvoiceVisible">
          <p><span class="invoice-text">索取样品</span></p>
        </div>
        <div class="score">
          <div class="score-item">
            <p class="score-title">质量稳定</p>
            <div class="start">
              <img
                :src="`${Number(detailsData.evaluate_quality_avg / 2) > index ? require('../../assets/images/start_active.png') : require('../../assets/images/start.png')}`"
                align="" class="start-img" v-for="(item, index) in 5" />
            </div>
            <span class="num">{{ detailsData.evaluate_quality_avg }}</span>
          </div>
          <div class="score-item">
            <p class="score-title">技术创新</p>
            <div class="start">
              <img
                :src="`${Number(detailsData.evaluate_technology_avg / 2) > index ? require('../../assets/images/start_active.png') : require('../../assets/images/start.png')}`"
                align="" class="start-img" v-for="(item, index) in 5" />
            </div>
            <span class="num">{{ detailsData.evaluate_technology_avg }}</span>
          </div>
          <span class="go-grade" @click="toStart()">
            我要点评
            <i class="grade-icon"></i>
          </span>
        </div>
      </div>
      <div class="product-desc" v-html="detailsData.product_description"></div>
      <div class="tab-btn">
        <span :class="`btn-item ${tabPanelIndex === 0 ? 'active' : ''}`" @click="changeTab(0)">产品详情</span>
        <span :class="`btn-item ${tabPanelIndex === 1 ? 'active' : ''}`" @click="changeTab(1)"
          v-show="supplyListTwo.length">优选商品</span>
        <span :class="`btn-item ${tabPanelIndex === 2 ? 'active' : ''}`" @click="changeTab(2)">专家互动</span>
        <span :class="`btn-item ${tabPanelIndex === 3 ? 'active' : ''}`" @click="changeTab(3)"
          v-show="courseList.length > 0">相关课堂</span>
        <span :class="`btn-item ${tabPanelIndex === 4 ? 'active' : ''}`" @click="changeTab(4)"
          v-show="proinfoList.length > 0">产品资讯</span>
      </div>
      <div class="tab-view">
        <div class="tab-box" v-show="tabPanelIndex === 0">
          <div class="tab-panel" v-if="companyData">
            <div class="product-details">
              <router-link :to="`/companyDetails?companyId=${this.companyId}`">
                <div class="top">
                  <img :src="companyData.pc_logo || config.DEFAULT_SHOP_LOGO" alt="" class="cover shop_logo" />
                  <div class="company-info">
                    <p class="name ">
                      <span>{{ companyData.common_service }}</span>
                      <img src="https://style-stg.ibuychem.com/wiseshop/pc/icon/company/company-50x50px.png" width="20"
                        alt=""><img :src="companyData.tags_img" width="20" alt="">
                    </p>
                    <p class="text">
                      <span class="product-label">商品丰富</span>
                      <span class="product-num">{{ companyData.quality }}</span>
                    </p>
                    <p class="text">
                      <span class="product-label">供应链支持</span>
                      <span class="product-num">{{ companyData.services }}</span>
                    </p>
                    <p class="text">
                      <span class="product-label">技术保障</span>
                      <span class="product-num">{{ companyData.innovation }}</span>
                    </p>
                    <p class="text">
                      <span class="product-label">供货稳定</span>
                      <span class="product-num">{{ companyData.service }}</span>
                    </p>
                    <p class="text">
                      <span class="product-label">快速响应</span>
                      <span class="product-num">{{ companyData.performance }}</span>
                    </p>
                  </div>
                </div>
              </router-link>
              <div class="video-box" v-if="supplierListData ? supplierListData.length : false">
                <span class="video-label">供应商</span>
                <div class="video-group">
                  <a :href="item.url ? item.url : 'javascript:;'" v-for="(item, index) in supplierListData"
                    :key="index">
                    <img :src="item.logo" alt="" class="video-img" />
                  </a>
                </div>
              </div>
              <div class="video-box" v-if="userListData ? userListData.length : false">
                <span class="video-label">客户</span>
                <div class="video-group">
                  <a :href="item.url ? item.url : 'javascript:;'" v-for="(item, index) in userListData" :key="index">
                    <img :src="item.logo" alt="" class="video-img" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-panel">
            <h3 class="panel-title">产品信息 Product Information</h3>
            <div class="product-info">
              <div class="info" v-if="detailsData.chemical_name">
                <p class="info-title">化学名称</p>
                <p class="info-name">{{ detailsData.chemical_name }}</p>
              </div>
              <div class="info" v-if="detailsData.colour || detailsData.physical_form">
                <p class="info-title">外观</p>
                <p class="info-name" v-html="detailsData.colour + detailsData.physical_form"></p>
              </div>
              <div class="info" v-if="detailsData.molecular_formula">
                <p class="info-title">化学式</p>
                <p class="info-name" v-html="detailsData.molecular_formula"></p>
              </div>
              <div class="info" v-if="detailsData.molecular_weight">
                <p class="info-title">分子量</p>
                <p class="info-name" v-html="detailsData.molecular_weight"></p>
              </div>
              <div class="info" v-if="detailsData.shelf_life">
                <p class="info-title">保质期</p>
                <p class="info-name"> {{ detailsData.shelf_life }} </p>
              </div>
            </div>
            <div class="product-type">
              <div class="type">
                <span class="label">产品分类</span>
                <ul class="type-list">
                  <li>{{ detailsData.position_class }}</li>
                </ul>
              </div>
              <div class="type" v-if="detailsData.application_class">
                <span class="label">应用分类</span>
                <ul class="type-list">
                  <li>{{ detailsData.application_class }}</li>
                </ul>
              </div>
            </div>
            <div class="characteristic" v-show="detailsData && detailsData.product_characteristics.length > 0">
              <p class="characteristic-title">性能特点</p>
              <div class="text" v-for="item in detailsData.product_characteristics">
                <div v-html="item.product_characteristics"></div>
              </div>
            </div>
            <div class="characteristic" v-show="detailsData && detailsData.storage_condition">
              <p class="characteristic-title">储存条件</p>
              <div class="text" v-html="detailsData.storage_condition"></div>
            </div>
          </div>
          <div class="tab-panel" v-if="detailsData.video_url">
            <h3 class="panel-title">产品视频 Product Video</h3>
            <div class="product-video">
              <video controls="controls" muted="muted" :src="detailsData.video_url" :poster="detailsData.video_img"
                crossorigin="anonymous" width="100%" v-if="detailsData.video_url"></video>
              <img :src="detailsData.video_img" v-else-if="detailsData.video_img" />
            </div>
          </div>
          <div class="tab-panel"
            v-if="detailsData ? detailsData.product_physical ? detailsData.product_physical.length ? true : false : false : false">
            <h3 class="panel-title">性能参数 Performance Parameter</h3>
            <div class="formula-table">
              <div class="thead">
                <div class="tr">
                  <span class="th">性能参数</span>
                  <span class="th">数值/单位</span>
                  <span class="th">测试条件/标准</span>
                </div>
              </div>
              <div class="tbody">
                <div class="tr" v-for="item in (detailsData.product_physical ? detailsData.product_physical : [])">
                  <span class="td" v-html="item.nature"></span>
                  <span class="td" v-html="item.number"></span>
                  <span class="td" v-html="item.condition"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-panel"
            v-if="detailsData ? (detailsData.case || detailsData.msds || detailsData.upload_instructions || detailsData.tds) ? true : false : false">
            <h3 class="panel-title">相关文件 Related Documents</h3>
            <div class="documents">
              <div class="item" v-show="detailsData.msds">
                <img src="https://style.ibuychem.com/wiseshop/pc/images/pdf.png" alt="" class="documents-img" />
                <div class="documents-info">
                  <a :href="'/#/pdf?src=' + encodeURIComponent(config.PHPHOST + detailsData.msds)">
                    <p class="name line-clamp-1">
                      {{ detailsData.munufacturer_abbreviation }}<span v-html="detailsData.product_name"></span><span
                        v-html="detailsData.grade"></span>化学品安全说明书(msds).pdf
                    </p>
                  </a>
                </div>
              </div>
              <div class="item" v-show="detailsData.tds">
                <img src="https://style.ibuychem.com/wiseshop/pc/images/pdf.png" alt="" class="documents-img" />
                <div class="documents-info">
                  <a :href="'/#/pdf?src=' + encodeURIComponent(config.PHPHOST + detailsData.tds)">
                    <p class="name line-clamp-1">
                      {{ detailsData.munufacturer_abbreviation }}<span v-html="detailsData.product_name"></span><span
                        v-html="detailsData.grade"></span>化学品技术说明书(tds).pdf
                    </p>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-panel">
            <h3 class="panel-title">生产商信息 Manufacturer Information</h3>
            <ul class="base-list">
              <li v-show="detailsData ? detailsData.place_of_origin ? true : false : false">
                <span class="label">产地</span>
                <span class="text">{{ detailsData.place_of_origin }}</span>
              </li>
              <li v-show="detailsData ? detailsData.munufacturer_abbreviation ? true : false : false">
                <span class="label">生产商简称</span>
                <span class="text">{{ detailsData.munufacturer_abbreviation }}</span>
              </li>
              <li v-show="detailsData ? detailsData.brand ? true : false : false">
                <span class="label">产品品牌</span>
                <span class="text" v-html="detailsData.brand"></span>
              </li>
              <li v-show="detailsData.grade">
                <span class="label">产品型号</span>
                <span class="text" v-html="detailsData.grade"></span>
              </li>
            </ul>
          </div>
          <div class="tab-panel" v-if="industryIndexLists.length > 0">
            <h3 class="panel-title">行业指数 Industry Index</h3>
            <ul class="industry-list">
              <li v-for="item of industryIndexLists" :key="item.name"><a :href="item.url">
                  <p>{{ item.name }}</p><b>{{ item.exponential || 0 }}</b>
                  <div :class="item.riseStr <= 0 ? 'green' : 'red'"><span>{{ item.risePercentageStr || '0.00%' }}</span>
                  </div>
                </a></li>
            </ul>
          </div>
          <div class="tab-panel recommed-list">
            <h3 class="panel-title">相关推荐 Relevant Recommendations</h3>
            <div class="recommed-warrper">
              <div class="recommend-item" v-for="(item, index) in recommendPorListOdd"
                @click="toDetails(item.details_id)">
                <div class="recommend-title-warrper">
                  <h3 class="recommend-title line-clamp-2">{{ item.product_name }}</h3>
                </div>
                <p class="recommend-text line-clamp-1">CAS: {{ item.cas_number }}</p>
                <p class="recommend-text line-clamp-1">牌号: {{ item.grade }}</p>
                <p class="recommend-text line-clamp-1">商标: {{ item.trademark }}</p>
              </div>
            </div>
            <div class="recommed-warrper">
              <div class="recommend-item" v-for="(item, index) in recommendPorListEven"
                @click="toDetails(item.details_id)">
                <div class="recommend-title-warrper">
                  <h3 class="recommend-title line-clamp-2">{{ item.product_name }}</h3>
                </div>
                <p class="recommend-text line-clamp-1">CAS: {{ item.cas_number }}</p>
                <p class="recommend-text line-clamp-1">牌号: {{ item.grade }}</p>
                <p class="recommend-text line-clamp-1">商标: {{ item.trademark }}</p>
              </div>
            </div>
          </div>
          <a :href="`/#/companyDetails?companyId=${this.companyId}`" class="more-btn">
            查看更多
            <img src="../../assets/images/more-boxshadow.png" alt="">
          </a>
        </div>
        <div class="tab-box" v-show="tabPanelIndex === 1">
          <div class="supply-warrper">
            <div class="tab-panel supply-item" v-for="item in supplyListTwo">
              <div class="supply-left">
                <h3 class="supply-title line-clamp-1">{{ item.goods_name }}{{ item.grade }}</h3>
                <div>
                  <p class="supply-info">
                    <span class="supply-label">牌号</span>
                    <span class="supply-text">{{ item.grade }}</span>
                  </p>
                  <p class="supply-info">
                    <span class="supply-label">价格</span>
                    <span class="supply-text"><b class="blue">{{ item.price }}</b> <i v-show="item.price != '面议'"
                        class="price">元/吨</i></span>
                  </p>
                </div>
              </div>
              <button class="supply-btn" @click="toLink(item.url)">
                购买
              </button>
            </div>
          </div>
        </div>
        <div class="tab-box" v-show="tabPanelIndex === 2">
          <div class="tab-panel" v-show="expertList ? expertList.length ? true : false : false">
            <h3 class="panel-title">优选专家 Optimization Expert</h3>
            <div class="recommend-expert">
              <div class="expert-item" v-for="item in expertList">
                <a :href="`${config.MAPI}/expert/${item.id}`"><img :src="item.logoUrl" alt="" class="cover" /></a>
                <p class="name">{{ item.fullname }}
                  <img src="../../assets/images/expert-level-icon.png" v-if="item.innovateFlag === 1" />
                </p>
                <p class="type" v-if="item.expertLabels && item.expertLabels[0] && item.expertLabels[0].labelName3">{{
                  item.expertLabels[0].labelName3 }}</p>
              </div>
            </div>
          </div>
          <div class="tab-panel relative">
            <div class="suply-btn" @click="doProblem()">
            </div>
            <h3 class="panel-title">互动问题 Q&A</h3>
            <div class="interact">
              <div class="interact-list">
                <div class="interact-item" v-for="(item, index) in commentList">
                  <div class="user">
                    <div class="user-info">
                      <img :src="item.user_img" alt="" class="cover" />
                      <div class="base">
                        <p :class="`name ${item.user_type == 1 ? 'expert' : ''}`">{{ item.user_type == 0 ? '用户' : '专家'
                        }}-{{ item.user_name }}
                          {{ item.user_type == 1 ? ('|' + item.expert_good) : '' }}</p>
                        <p class="time">{{ item.add_time }}</p>
                      </div>
                    </div>
                    <span class="reply-btn" @click="doReply(item)"><i class="icon"></i><a class="reply-text">回复({{
                      commentLevelTwoList[index] ? commentLevelTwoList[index].model ?
                        commentLevelTwoList[index].model.length : '' : '' }})</a></span>
                  </div>
                  <div class="interact-warrper">
                    <div :data-open="item.isOpen ? 1 : 2" :class="`interact-text ${item.isOpen ? '' : 'line-clamp-3'}`">
                      {{ item.isOpen ? item.interactive_content : (item.interactive_content.slice(0, 63) + '...') }}
                    </div>
                    <span class="show-btn" @click="openComment(index)"
                      v-show="item.interactive_content ? item.interactive_content.length > 63 ? true : false : false">{{
                        item.isOpen ? '收起' : '展开' }}</span>
                  </div>
                  <div class="other-reply"
                    v-show="commentLevelTwoList[index] ? commentLevelTwoList[index].model.length ? true : false : false">
                    <div class="interact-item"
                      v-for="(items, dataIndex) in commentLevelTwoList[index] ? commentLevelTwoList[index].model ? commentLevelTwoList[index].model : [] : []">
                      <div class="user">
                        <div class="user-info">
                          <img :src="items.user_img" alt="" class="cover" />
                          <div class="base">
                            <p :class="`name ${items.user_type == 1 ? 'expert' : ''}`">{{ items.user_type == 0 ? '用戶' :
                              '专家' }}-{{ items.user_name }}
                              {{ items.user_type == 1 ? ('|' + items.expert_good) : '' }} </p>
                            <p class="time">{{ items.add_time }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="interact-warrper">
                        <div :data-open="commentLevelTwoList[index].model[dataIndex].isOpen ? 1 : 2"
                          :class="`interact-text ${commentLevelTwoList[index].model[dataIndex].isOpen ? '' : 'line-clamp-3'}`">
                          {{ commentLevelTwoList[index].model[dataIndex].isOpen ? items.interactive_content :
                            (items.interactive_content.slice(0, 63) + '...') }}
                        </div>
                        <span class="show-btn" @click="openCommentLevelTwo(index, dataIndex)"
                          v-show="items.interactive_content ? items.interactive_content.length > 63 ? true : false : false">{{
                            commentLevelTwoList[index].model[dataIndex].isOpen ? '收起' : '展开' }}</span>
                      </div>
                    </div>
                    <p class="get-more"><span class="more-text"
                        @click="downloadCommentLevelTwo(index, commentList[index].interactive_id)"
                        v-show="commentLevelTwoList[index] ? commentLevelTwoList[index].page_count ? commentLevelTwoList[index].page >= commentLevelTwoList[index].page_count ? false : true : false : false">查看更多
                        <i class="more-icon"></i></span></p>
                  </div>
                </div>
              </div>
              <p class="get-more"><span class="more-text" @click="downloadComment()"
                  v-show="!commentIsLoading && commentList.length > 0">查看更多
                  <i class="more-icon"></i></span></p>
            </div>
          </div>
        </div>
        <div class="tab-box" v-show="tabPanelIndex === 3">
          <div class="classroom-list">
            <div class="item" v-for="item in courseList" :key="item.id">
              <a :href="`${config.MAPI}/courses/${item.id}?type=${item.type}`">
                <img :src="`${config.API}courses/downLoadImg?annexId=${item.img5}`" alt="" class="cover" />
                <h3 class="calss-title">{{ item.title }}</h3>
                <p class="teacher">主讲：{{ item.lecturer }}</p>
              </a>
            </div>
          </div>
        </div>
        <div class="tab-box" v-show="tabPanelIndex === 4">
          <ul class="proinfo-list">
            <template v-for="item in proinfoList">
              <li class="img" :key="item.id" v-if="item.picUrl">
                <a :href="item.detailUrl" class="imgs"><img :src="item.picUrl"></a>
                <a :href="item.detailUrl" target="_blank" class="liss" v-html="item.articleName"></a>
                <span>{{ item.releaseTime | toDate }}</span>
              </li>
              <li :key="item.id" v-else>
                <a :href="item.detailUrl" target="_blank" class="lis" v-html="item.articleName"></a>
                <span>{{ item.releaseTime | toDate }}</span>
              </li>
            </template>
            <p class="loading-text" v-show="proinfoPage > 1 && !proinfoOver">下拉获取更多...</p>
          </ul>
        </div>
      </div>
    </div>
    <Footer />
    <mt-popup v-model="popupVisible2" popup-transition="popup-fade" position="bottom">
      <City :success="success" :remove="remove" />
    </mt-popup>
    <Toast :text="toastText" :visible="toastVisible" />
    <demand-btn :instance="$demoInstance"
      :save-options="{ data_source: 2, u_source: 1, crm_source: source === 'cms' ? 1 : 0 }" />
  </div>
</template>
<script>
  import header from "../common/header";
  import footer from "../common/footer";
  import config from "../../common/config";
  import axios from "axios";
  import qs from "qs";
  import toast from "../ui/toast.vue";
  import city from "../ui/city.vue";
  export default {
    name: "",
    data() {
      return {
        config,
        id: "",
        source: '',
        munufacturer_id: "",
        status: "",
        rateOneNum: 0,
        rateTwoNum: 0,
        dialogStartShow: false, //弹框
        dialogInvoiceShow: false, //弹框
        dialogCommentShow: false, //弹框
        tabPanelIndex: 0,
        companyId: "", // 公司id
        spFactory: "", //  生产商
        productName: "", // 商品名称
        detailsData: "", // 详情
        companyData: "", // 公司
        recommendPorList: [],
        userListData: [], // 用户
        supplierListData: [], //供应商
        supplyListTwo: [], //优选商品
        expertList: [], // 专家
        page: 1, // 分页
        isLoading: false, // 加载状态
        commentList: [], // 评论列表
        commentPage: 1,
        commentIsLoading: false,
        commentLevelTwoList: [],
        replyType: 1, // 1回復
        suplyText: "", //  提交文本
        suplyTextLength: 0,
        productId: "",
        pid: "",
        showCompanyIcon: false,
        modelSampleUser: "", // 小样联系人
        modelSampleTel: "", // 小样手机
        modelSampleCompany: "", // 小样公司
        modelSampleJob: "", // 小样职位
        modelSampleMessage: "", // 留言
        toastText: "", // 提示内容
        toastVisible: false, // 提示框
        toastTimer: null,
        userInfo: null, // 用户信息
        courseList: [], // 相关课程列表
        courseLoading: false, // 相关课程加载中
        courseLoadOver: false, // 相关课程没有更多数据
        coursePage: 0, // 相关课程页码
        popupVisible2: false,
        myCity: "",
        province: "",
        city: "",
        district: "",
        detailed_address: "",
        content: "",
        province_str: "",
        city_str: "",
        district_str: "",
        proinfoList: [], // 产品咨询
        proinfoPage: 0, // 页码
        proinfoLoading: false, // 加载状态
        proinfoOver: false, // 更多数据
        industryIndexLists: [],

        integralTimer: null, // 积分任务计时器
      };
    },
    filters: {
      // 立即使用
      toDate(number) {
        var n = number;
        var date = new Date(n);
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10 ?
            "0" + (date.getMonth() + 1) :
            date.getMonth() + 1) + "-";
        var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        return Y + M + D;
      }
    },
    watch: {
      $route: function (from, to) {
        if (from.name === to.name) {
          Object.assign(this.$data, this.$options.data());
          this.init();
        }
      }
    },
    created() {
      this.init();
    },
    mounted() {
      window.addEventListener("scroll", this.handleScroll);
      this.integralTimer = integral.delay({
        env: config.ENV === "production" ? "pro" : "dev",
        code: "00_03_00_001",
        entityType: "ylk_goods",
        system: 3,
        entityId: this.id,
        callback: function () { }
      },
        15000
      );
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
      if (this.integralTimer) {
        clearTimeout(this.integralTimer);
      }
    },
    computed: {
      recommendPorListOdd: function () {
        var result = [];
        this.recommendPorList.map((v, k) => {
          if (k % 2 === 0) {
            result.push(v);
          }
        });
        return result;
      },
      recommendPorListEven: function () {
        var result = [];
        this.recommendPorList.map((v, k) => {
          if (k % 2 !== 0) {
            result.push(v);
          }
        });
        return result;
      }
    },
    methods: {
      init() {
        this.id = this.$route.query.id;
        this.source = this.$route.query.source
        this.munufacturer_id = this.$route.query.munufacturer_id;
        this.status = this.$route.query.status || "";
        window.scrollTo(0, 0);
        _hmt.push(["_trackPageview", `/${window.location.hash}`]);
        this.getData();
        this.getSampleData();
      },
      toStart() {
        if (!this.userInfo) {
          return (window.location.href =
            config.USERAPI +
            "mobile/uc/build/login?returnUrl=" +
            encodeURIComponent(encodeURIComponent(window.location.href)));
        }
        this.dialogStartShow = true;
      },
      toast(text) {
        this.toastText = text;
        this.toastVisible = true;
        if (this.toastTimer) clearTimeout(this.toastTimer);
        this.toastTimer = setTimeout(() => {
          this.toastText = "";
          this.toastVisible = false;
        }, 2000);
      },
      success(val) {
        const str =
          val[0].region_name +
          "-" +
          val[1].region_name +
          "-" +
          val[2].region_name;
        this.myCity = str;

        this.province_str = val[0].region_name;
        this.city_str = val[1].region_name;
        this.district_str = val[2].region_name;
        this.province = val[0].id;
        this.city = val[1].id;
        this.district = val[2].id;
        this.popupVisible2 = false;
      },
      remove() {
        this.popupVisible2 = false;
      },
      openCity() {
        this.popupVisible2 = true;
      },
      getSampleData() {
        axios
          .get(
            config.PHPHOST +
            "api/web/index.php?r=second/purchase-intention/index&type=" +
            2
          )
          .then(res => {
            if (res.data.error_code === 0) {
              const data = res.data.data ? res.data.data.model[0] : {};
              this.detailed_address = data.detailed_address;
              this.myCity = data.province_str + data.city_str + data.district_str;
              this.province_str = data.province_str;
              this.city_str = data.city_str;
              this.district_str = data.district_str;
              this.province = data.province;
              this.city = data.city;
              this.district = data.district;
              this.content = data.content;
            }
          });
      },
      /**
       * 用户信息
       * @param {Object} data 用户信息
       */
      getUserInfo(data) {
        this.userInfo = data;
        this.modelSampleUser = data.name;
        this.modelSampleTel = data.mobile;
        this.modelSampleCompany = data.company;
        this.modelSampleJob = data.duty;
      },
      // 索取样品可视化
      setDialogInvoiceVisible() {
        this.$demoInstance.show({
          goods_name: this.detailsData.product_name,
          goods_id: this.id,
          company_id: this.companyId,
          data_source: 2,
          crm_source: this.source === 'cms' ? 1 : 0
        }, {
          productName: this.detailsData.product_name,
          model: this.detailsData.grade,
          manufacturer: this.detailsData.munufacturer_name
        });
      },
      submitStart() {
        axios
          .post(
            config.PHPHOST +
            "api/web/index.php?r=second/product/evaluate-product",
            qs.stringify({
              detailsId: this.id,
              quality: this.rateOneNum * 2,
              technology: this.rateTwoNum * 2
            })
          )
          .then(res => {
            if (res.data.error_code === 0) {
              this.dialogStartShow = false;
              this.toast("点评成功！");
            }
          });
      },
      toLink(url) {
        window.location.href = url;
      },
      // 字数统计
      changeText(e) {
        var val = e.target.value;
        this.suplyTextLength = val.length;
      },
      // 取消
      removeReply() {
        this.suplyText = "";
        this.suplyTextLength = 0;
        this.dialogCommentShow = false;
      },
      // 提交
      submitReply() {
        axios
          .post(
            config.PHPHOST +
            "api/web/index.php?r=second/interactive/save-interactive",
            qs.stringify({
              PRODUCT_ID: this.id,
              PRODUCT_NAME: this.productName,
              INTERACTIVE_CONTENT: this.suplyText,
              INTERACTIVE_TYPE: this.replyType === 1 ? 1 : 0,
              PID: this.replyType === 1 ? this.pid : 0,
              INFO_TYPE: 1
            })
          )
          .then(res => {
            if (res.data.error_code === 0) {
              this.suplyText = "";
              this.suplyTextLength = 0;
              this.dialogCommentShow = false;
              this.toast("信息提交成功，工作人员审核通过后即可浏览您的互动信息");
            }
          });
      },
      // 回復
      doReply(data) {
        if (!this.userInfo) {
          return (window.location.href =
            config.USERAPI +
            "mobile/uc/build/login?returnUrl=" +
            encodeURIComponent(encodeURIComponent(window.location.href)));
        }
        this.replyType = 1;
        this.dialogCommentShow = true;
        this.productId = data.product_id;
        this.pid = data.interactive_id;
      },
      // 发布问题
      doProblem() {
        if (!this.userInfo) {
          return (window.location.href =
            config.USERAPI +
            "mobile/uc/build/login?returnUrl=" +
            encodeURIComponent(encodeURIComponent(window.location.href)));
        }
        this.replyType = 0;
        this.dialogCommentShow = true;
      },
      openComment(index) {
        var newData = [...this.commentList];
        if (newData[index].isOpen) {
          newData[index].isOpen = false;
        } else {
          newData[index].isOpen = true;
        }
        this.commentList = newData;
      },
      openCommentLevelTwo(index, dataIndex) {
        var newData = [...this.commentLevelTwoList];
        if (newData[index].model[dataIndex].isOpen) {
          newData[index].model[dataIndex].isOpen = false;
        } else {
          newData[index].model[dataIndex].isOpen = true;
        }
        this.commentLevelTwoList = newData;
      },
      getAuth() {
        axios
          .get(
            config.API +
            "out/api/company/attestation/check?companyId=" +
            this.companyId
          )
          .then(res => {
            if (res.data.code === 1) {
              this.showCompanyIcon = res.data.obj;
            }
          });
      },
      // tab
      changeTab(index) {
        this.tabPanelIndex = index;
      },
      getData() {
        axios
          .get(
            config.PHPHOST +
            "api/web/index.php?r=second/product/detail&detailsId=" +
            this.id +
            "&portType=2"
          )
          .then(res => {
            if (res.data.error_code === 0) {
              this.detailsData = res.data.data;
              this.detailsData.product_characteristics =
                res.data.data.product_characteristics;
              this.companyId = res.data.data.munufacturer_id; // 公司id || 生产商id
              this.spFactory = res.data.data.munufacturer_name; // 生产商
              this.productName = res.data.data.product_name;
              this.modelSampleMessage =
                res.data.data.product_name + (res.data.data.cas_number || "");
              if (res.data.data.munufacturer_id) {
                this.getSupplyTwo();
                this.getComponentInfo(res.data.data.munufacturer_id);
                this.getUserList(res.data.data.munufacturer_id);
                this.getAuth();
                this.getCommentList();
                this.getExpertList();
                this.getRecommendList();
                this.getCourseList();
                this.getProinfoList();
                this.getRise();
              }
              // 产品名称 productName  生产商简称 munAbb 商标trademark  牌号 grade
              var _title =
                this.detailsData.product_name + "-优料库-材料创新者智慧数据库";
              _title = _title.replace(/<sup>|<\/sup>/gim, "");
              document.title = _title;
              WeChatShare({
                callback: () => {
                  var desc = "",
                    imgUrl = config.PHPHOST + "frontend/web/images/logo-new.jpg",
                    link =
                      window.location.origin +
                      "/#/prodetail?id=" +
                      this.id +
                      `&munufacturer_id=${this.munufacturer_id}`;
                  if (this.detailsData.product_description) {
                    desc = this.detailsData.product_description;
                    desc = desc.replace(/<sup>|<\/sup>/gim, "");
                  } else {
                    desc =
                      "在线支持原料性能搜索,通过覆盖全球供应商的产品数据库资源,为用户提供数据查询、资料下载、在线培训和试样申请等专业信息服务。";
                  }
                  wx.onMenuShareAppMessage({
                    title: _title,
                    desc: desc,
                    link: link,
                    imgUrl: imgUrl
                  });
                  wx.onMenuShareTimeline({
                    title: _title + " - " + desc,
                    link: link,
                    imgUrl: imgUrl
                  });
                },
                data: "url=" + encodeURIComponent(window.location.href),
                url: config.MAPI
              });
            }
          });
      },
      // 公司
      getComponentInfo(id) {
        axios
          .post(
            config.MallApi + "api/wshop/shop/shop-visiting-card",
            qs.stringify({
              companyId: id
            })
          )
          .then(res => {
            if (res.data.error_code === 0) {
              this.companyData = res.data.data;
            }
          });
      },
      // 客户
      getUserList(id) {
        axios
          .get(
            config.MallApi + "api/wshop/shop/supplier-customers?companyId=" + id
          )
          .then(res => {
            if (res.data.error_code === 0) {
              this.userListData = res.data.data.preferred_customers;
              this.supplierListData = res.data.data.material_supplier;
            }
          });
      },
      // 推荐产品
      getRecommendList() {
        axios
          .post(
            config.PHPHOST + "api/web/index.php?r=second/product/munufacturer",
            qs.stringify({
              companyId: this.companyId
            })
          )
          .then(res => { });
      },
      // 优选商品
      getSupplyTwo() {
        axios
          .get(
            config.MallApi +
            "api/wshop/goods/ylk-goods?productName=" +
            this.productName +
            "&grade=" +
            this.detailsData.grade
          )
          .then(res => {
            if (res.data.error_code === 0) {
              this.supplyListTwo = res.data.data;
            }
          });
      },
      // 推荐
      getRecommendList() {
        if (!this.isLoading) {
          this.isLoading = true;
        }
        axios
          .post(
            config.PHPHOST + "api/web/index.php?r=second/product/munufacturer",
            qs.stringify({
              companyId: this.companyId,
              goodsId: this.detailsData.details_id,
              page: this.commentPage,
              pageSize: 8
            })
          )
          .then(res => {
            if (res.data.error_code === 0) {
              var data = res.data.data.model;
              var totalNum = Number(res.data.data.total_num);
              var isEnd = this.page >= Math.ceil(totalNum / 10) ? true : false;
              if (!isEnd) {
                this.isLoading = false;
              }
              this.recommendPorList = this.recommendPorList.concat(data);
            }
          });
      },
      // 推荐加载
      downloadRecommend() {
        this.page = this.page + 1;
        this.getRecommendList();
      },
      toDetails(id) {
        const url = window.location.href.replace(/id=\d*[^&]*/, "id=" + id);
        window.location.href = url;
      },
      // 专家
      getExpertList() {
        axios
          .post(
            config.API + "out/api/expert/companyExpert",
            qs.stringify({
              companyId: this.companyId,
              num: 9999
            })
          )
          .then(res => {
            if (res.data.code === 1) {
              this.expertList = res.data.obj;
            }
          });
      },
      // 加载评论
      downloadComment() {
        this.commentPage = this.commentPage + 1;
        this.getCommentList();
      },
      // 获取评论
      getCommentList() {
        if (!this.commentIsLoading) {
          this.commentIsLoading = true;
        }
        axios
          .post(
            config.PHPHOST +
            "api/web/index.php?r=second/interactive/interactive-list",
            qs.stringify({
              Id: this.id,
              typeId: 1,
              page: this.commentPage,
              pageSize: 10
            })
          )
          .then(res => {
            if (res.data.error_code === 0) {
              if (!res.data.data.model) {
                return;
              }
              var totalNum = Number(res.data.data.total_num);
              var isEnd =
                this.commentPage >= Math.ceil(totalNum / 10) ? true : false;
              if (!isEnd) {
                this.commentIsLoading = false;
              }
              this.commentList = this.commentList.concat(res.data.data.model);
              if (res.data.data.model) {
                this.promiseComment([...res.data.data.model]);
              }
            }
          });
      },
      // 加载留言
      downloadCommentLevelTwo(index, id) {
        axios
          .post(
            config.PHPHOST +
            "api/web/index.php?r=second/interactive/interactive-id",
            qs.stringify({
              interactiveId: id,
              pageSize: 2,
              page: Number(this.commentLevelTwoList[index].page) + 1
            })
          )
          .then(data => {
            if (!data.data.data.model) {
              return;
            }
            this.commentLevelTwoList[index].model = this.commentLevelTwoList[
              index
            ].model.concat(data.data.data.model);
            this.commentLevelTwoList[index].page = Number(data.data.data.page);
          });
      },
      // 获取留言
      promiseComment(arr) {
        const that = this;
        (arr => {
          let fn = new Promise((res, rej) => {
            axios
              .post(
                config.PHPHOST +
                "api/web/index.php?r=second/interactive/interactive-id",
                qs.stringify({
                  interactiveId: arr[0].interactive_id,
                  pageSize: 2,
                  page: arr[0].page ? arr[0].page : 1
                })
              )
              .then(data => {
                res(data);
              });
          });
          fn.then(newRes => {
            that.commentLevelTwoList = that.commentLevelTwoList.concat([
              newRes.data.data.model ? newRes.data.data : { model: [] }
            ]);
            arr.shift();
            if (arr.length > 0) {
              that.promiseComment(arr);
            }
          });
        })(arr);
      },
      //评分
      changeStart(name, index) {
        if (name === "one") {
          this.rateOneNum = index + 1;
        } else if (name === "two") {
          this.rateTwoNum = index + 1;
        }
      },
      /**
       * 跳转到店铺
       * @param {Object} url 店铺链接
       */
      gotoShop(url) {
        window.location.href = url;
      },
      /**
       * 获取行业指数
       */
      getRise() {
        let industryIndexArr = [];
        axios
          .get(
            config.EXAPI1 +
            "wap/exponential/rise?expKeys=" +
            encodeURIComponent(
              encodeURIComponent(this.detailsData.position_exponential)
            )
          )
          .then(r => {
            r = r.data;
            industryIndexArr = [];
            for (const key in r.obj) {
              let object = r.obj;
              if (Object.hasOwnProperty.call(object, key)) {
                const element = object[key];
                element.name = key.slice(0, -2);
                industryIndexArr.push(element);
              }
            }
            this.industryIndexLists = industryIndexArr;
          });
      },
      /**
       * [getCourseList 获取相关课程]
       * @return null
       */
      getCourseList() {
        if (this.courseLoading || this.courseLoadOver) return;
        this.courseLoading = true;
        this.coursePage++;
        axios
          .post(
            config.API + "out/api/expert/courses",
            qs.stringify({
              companyId: this.companyId,
              pageNo: this.coursePage,
              pageSize: 10
            })
          )
          .then(r => {
            r = r.data;
            this.courseLoading = false;
            if (r.code === 0) {
              this.courseList = [...this.courseList, ...r.data.list];
              if (r.data.pageNum >= r.data.pages) {
                this.courseLoadOver = true;
              }
            }
          });
      },
      /**
       * [getCourseList 获取产品资讯]
       * @return null
       */
      getProinfoList() {
        if (this.proinfoLoading || this.proinfoOver) return;
        this.proinfoLoading = true;
        this.proinfoPage++;
        axios
          .post(
            config.API + "api/articles/query",
            qs.stringify({
              titles: this.detailsData.product_name,
              pageNum: this.proinfoPage,
              pageSize: 10
            })
          )
          .then(r => {
            r = r.data;
            this.proinfoLoading = false;
            if (r.code === 1) {
              this.proinfoList = [...this.proinfoList, ...r.obj.list];
              if (r.obj.pageNum >= r.obj.pages) {
                this.proinfoOver = true;
              }
            }
          });
      },
      /**
       * [handleScroll 滚动加载数据]
       * @return null
       */
      handleScroll() {
        if (this.tabPanelIndex === 4) {
          if (this.proinfoLoading || this.proinfoOver) return;
          if (
            document.body.scrollHeight -
            document.body.scrollTop -
            window.innerHeight <
            150 ||
            document.body.scrollHeight -
            document.documentElement.scrollTop -
            window.innerHeight <
            150
          ) {
            this.getProinfoList();
          }
        }
        if (this.tabPanelIndex === 3) {
          if (this.courseLoading || this.courseLoadOver) return;
          if (
            document.body.scrollHeight -
            document.body.scrollTop -
            window.innerHeight <
            150 ||
            document.body.scrollHeight -
            document.documentElement.scrollTop -
            window.innerHeight <
            150
          ) {
            this.getCourseList();
          }
        }
      },

      // 编辑
      editAction() {
        window.location.href = `${config.USERAPI
          }mobile/uc/build/u/product/edit?id=${this.id}&type=${this.detailsData.product_equipment
          }&source=${this.detailsData.status}`;
      },

      // 收藏
      favAction() {
        axios
          .post(
            config.PHPHOST + "api/web/index.php?r=member/product/save-collect",
            qs.stringify({
              id: this.id,
              type: this.detailsData.ollect_type
            })
          )
          .then(r => {
            if (r.data.error_code === 0) {
              this.$set(
                this.detailsData,
                "ollect_type",
                this.detailsData.ollect_type === 1 ? 2 : 1
              );
            } else {
              this.toast(r.data.msg);
            }
          });
      },

      // 认领
      rlAction() {
        axios
          .post(
            config.PHPHOST + "api/web/index.php?r=member/product/add-claim",
            qs.stringify({
              detailsId: this.id
            })
          )
          .then(r => {
            if (r.data.error_code === 0) {
              this.$set(this.detailsData, "claimant", 1);
            } else {
              this.toast(r.data.msg);
            }
          });
      }
    },
    components: {
      Header: header,
      Footer: footer,
      Toast: toast,
      City: city
    }
  };

</script>
<style scoped lang="less">
  .page-productDetails {
    background: #0a1a5d;
    font-size: 1.2rem;
    color: #333;
    font-family: "微软雅黑";
    display: flex;
    flex-direction: column;
    height: 100%;

    button,
    textarea,
    input {
      outline: none;
      box-sizing: border-box;
    }

    .line-clamp-3 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .line-clamp-2 {
      display: block;
      line-height: 24px !important;
      height: 48px !important;
      overflow: hidden;
    }

    .page-content {
      position: relative;
      background: #f8f8f8;
      border-top-left-radius: 2.92rem;
      border-top-right-radius: 2.92rem;
      padding: 3.25rem 1.25rem 0;
      flex: 1;

      .get-invoice {
        width: 100%;
        height: 2.5rem;
        text-align: center;
        margin-top: 1.5rem;

        .invoice-text {
          width: 94%;
          height: 2.75rem;
          line-height: 2.75rem;
          border-radius: 0.5rem;
          display: inline-block;
          font-size: 1.25rem;
          color: #fff;
          background: #0c317a;
        }
      }
    }

    .text-center {
      text-align: center;
    }

    .block {
      display: block !important;
    }

    .dialog {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1000;

      &.dialog-big {
        .dialog-content {
          width: 90%;

          .my-score {
            width: 100%;
            height: 40rem;
            overflow-y: auto;
          }

          .score-submit {
            height: 3.2rem;
          }
        }

        .invoice-form {
          .form-input-warrper {
            margin-top: 1rem;

            .label {
              padding-bottom: 1rem;
            }

            .input {
              height: 3.2rem;
            }

            .select-input {
              position: relative;
              width: 100%;
              height: 3.2rem;
              padding: 0 0.5rem;
              border: 1px solid #c7c7c7;
              border-radius: 0.25rem;
              background: #fff;
              text-align: left;

              &:after {
                content: "";
                position: absolute;
                top: 1.3rem;
                right: 0.5rem;
                width: 0;
                height: 0;
                border-top: 0.45rem solid #000;
                border-left: 0.45rem solid transparent;
                border-right: 0.45rem solid transparent;
              }
            }
          }
        }
      }

      &.comment {
        background: #fff;

        .dialog-content {
          top: 0;
          left: 0;
          transform: none;
          display: block;
        }

        .supply-comment {
          .comment-head {
            display: flex;
            height: 4.83rem;
            padding: 0 1.45rem 0 1.75rem;
            background: #eaedf7;
            justify-content: space-between;
            align-items: center;
            line-height: 4.83rem;

            .left {
              font-size: 1.2rem;
              color: #474644;
            }

            .title {
              font-size: 1.5rem;
            }

            .right {
              width: 4.5rem;
              height: 2.08rem;
              border: 0.04rem solid #fff;
              background: #597eff;
              border-radius: 1.66rem;
              font-size: 1.2rem;
              font-weight: 900;
              color: #fff;
            }
          }

          .comment-content {
            textarea {
              width: 100%;
              height: 19rem;
              border: 0;
              padding: 1.75rem;
              box-sizing: border-box;
              font-size: 1.3rem;
              line-height: 1.6rem;

              &::placeholder {
                color: #999;
              }
            }

            .max-length {
              padding: 0.5rem 0 0 1.75rem;
              color: #999;
            }
          }
        }
      }

      .dialog-content {
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: inline-block;
      }

      .dialog-close {
        position: absolute;
        right: -1.2rem;
        top: -1.2rem;
        width: 3.33rem;
        height: 3.33rem;
        display: inline-block;
        background: url("../../assets/images/close.png") no-repeat scroll top/cover;
      }

      .my-score {
        width: 21rem;
        background: #fff;
        border-radius: 0.58rem;
        overflow: hidden;

        .my-score-title {
          line-height: 3.75rem;
          text-align: center;
          background: #eaedf7;
          color: #0c2870;
          font-size: 1.4rem;
        }

        .score-group {
          padding: 3.25rem 1.6rem 2.58rem;
          overflow: hidden;

          .score-item {
            padding: 0 1rem;
            margin-bottom: 2.58rem;

            .score-title {
              color: #49557f;
            }

            .score-box {
              display: flex;
              margin-top: 0.83rem;
              justify-content: space-between;

              .scores {}

              .score-img {
                width: 1.54rem;
                height: 1.54rem;
                margin-right: 0.83rem;
              }

              .num {
                font-size: 1.6rem;
                font-weight: 900;
                line-height: 1.54rem;
                color: #001eed;
              }
            }
          }
        }

        .score-submit {
          width: 100%;
          height: 2.8rem;
          background: #597eff;
          color: #fff;
          border: 0;
          font-size: 1.4rem;
          border-radius: 2.33rem;
        }
      }

      .invoice-form {
        padding: 1.75rem 2.08rem 1.8rem;

        .form-input-warrper {
          margin-bottom: 0.6rem;

          .label {
            padding-bottom: 0.45rem;
            color: #666;
          }

          .input {
            width: 100%;
            height: 2.5rem;
            padding: 0 0.5rem;
            border: 0.045rem solid #c7c7c7;
            border-radius: 0.25rem;

            &:focus {
              border: 0.045rem solid #a6bbff;
            }
          }

          .textarea {
            width: 100%;
            height: 6.1rem;
            border: 0.045rem solid #c7c7c7;
            border-radius: 0.25rem;
            padding: 0.5rem;

            &:focus {
              border: 0.045rem solid #a6bbff;
            }
          }
        }
      }
    }

    .top-base {
      .info-content {
        padding: 0 5rem 0 1rem;
      }

      .top-title {
        font-size: 2rem;
        font-weight: 900;
        line-height: 2.4rem;
      }

      .subtitle {
        padding-top: 1rem;
        font-size: 1.2rem;
        line-height: 1.5rem;
        margin-bottom: 1.5rem;

        .company {
          font-size: 1.2rem;
          font-weight: 900;
          margin: 0 0.42rem 0 0.84rem;
        }

        .company-icon {
          width: 1.5rem;
          height: 1.5rem;
          display: inline-block;
          margin-right: 0.82rem;
          background: url("../../assets/images/company.png") no-repeat scroll center/cover;
          vertical-align: text-bottom;
        }
      }

      .cas {
        padding: 0 0 1.5rem;
        font-size: 1.2rem;
      }

      .info {
        margin-bottom: 1.5rem;

        .label {
          margin-right: 0.33rem;
          font-size: 1.2rem;
          color: #999;
        }

        .text {
          margin-right: 1.625rem;
          font-size: 1.2rem;
        }
      }

      .score {
        padding: 2.08rem 0 0 1rem;
        display: flex;

        .score-item {
          position: relative;
          flex: 1 1;
          padding: 0 2% 0 6%;
          font-size: 1.2rem;

          &:first-child {
            padding-left: 0;
          }

          &:after {
            content: "";
            position: absolute;
            bottom: 0;
            right: 0;
            width: 0.084rem;
            height: 1.875rem;
            display: inline-block;
            background: #e6e6e6;
          }

          .score-title {
            color: #999;
          }

          .start {
            float: left;
            padding-top: 0.5rem;
            vertical-align: text-bottom;

            .start-img {
              width: 0.84rem;
              height: 0.84rem;
              margin-right: 0.23rem;
            }
          }

          .num {
            float: left;
            margin-top: 0.5rem;
            margin-left: 0.21rem;
            font-weight: 900;
            color: #666;
          }
        }
      }

      .go-grade {
        width: 27.5%;
        font-size: 1.2rem;
        line-height: 2.5rem;
        text-align: right;

        .grade-icon {
          width: 1.29rem;
          height: 0.71rem;
          display: inline-block;
          margin-left: 0.14rem;
          background: url("../../assets/images/right_blue.png") no-repeat scroll center/cover;
        }
      }
    }

    .tab-btn {
      height: 3.8rem;
      display: flex;
      padding: 0 0.6rem;
      margin: 1.66rem 0;
      border-radius: 2.5rem;
      background: url("../../assets/images/tab_bg.png") no-repeat scroll top/cover;
      background-size: 100% 100%;
      align-items: center;

      .btn-item {
        flex: 1 1;
        height: 3.1rem;
        margin-right: 0.58rem;
        border-radius: 1.8rem;
        text-align: center;
        line-height: 3.1rem;
        color: #525252;

        &.active {
          background: #597eff;
          color: #fff;
          border: 0.05rem solid #fff;
          font-weight: 900;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .tab-view {
      overflow: hidden;

      .relative {
        position: relative;
      }

      .suply-btn {
        position: absolute;
        top: 1.66rem;
        right: 0;
        width: 4.16rem;
        height: 4.16rem;
        display: inline-block;
        background: url("../../assets/images/suply_btn.png") no-repeat scroll top/cover;
      }
    }

    .tab-panel {
      background: #fff;
      padding: 1rem;
      border-radius: 1rem;
      margin-bottom: 1.83rem;
      box-shadow: 2px 2px 6px #ededed;

      .product-details {
        .top {
          display: flex;
          padding: 1.75rem 0 1.95rem 1.375rem;
          background: #f2f4fb;
          border-radius: 0.5rem;
          align-items: center;

          .cover {
            width: 7.29rem;
            height: 7.29rem;
            margin-right: 1.25rem;
          }

          .company-info {
            flex: 1 1;
            width: 20%;

            .name {
              // padding: 0.625rem 0 1.08rem;
              font-size: 1.4rem;
              margin-bottom: 1rem;
              font-weight: bold;

              >span {
                vertical-align: middle;
              }

              >img {
                vertical-align: middle;
                margin-right: 4px;
              }
            }

            .text {
              float: left;
              min-width: 50%;
              overflow: hidden;
              margin-bottom: 1rem;
            }

            .product-label {
              float: left;
              margin-right: 0.35rem;
              color: #999;
            }

            .product-num {
              float: left;
              color: #555;
              font-weight: 600;
            }
          }
        }

        .video-box {
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-top: 1.75rem;

          &:last-child {
            margin-bottom: 0.7rem;
          }

          .video-label {
            width: 4.33rem;
            height: 1.91rem;
            display: inline-block;
            font-size: 1.2rem;
            line-height: 1.91rem;
            text-align: center;
            border: 0.05rem solid #bababa;
            border-radius: 1.6rem;
            color: #999;
            margin-right: 2rem;
          }

          .video-group {
            flex: 1;

            .video-img {
              width: 4.25rem;
              height: 4.25rem;
              margin-right: 0.75rem;
              margin-bottom: 0.5rem;
            }

            a:last-child {
              .video-img {
                margin-right: 0;
              }
            }
          }

          .video-next {
            width: 0.58rem;
            height: 0.95rem;
            display: inline-block;
            margin-right: 0.2rem;
            background: url("../../assets/images/right_black.png") no-repeat scroll center/cover;
          }
        }
      }

      .panel-title {
        padding: 1.2rem 0 0.5rem 0.66rem;
        font-size: 1.5rem;
        color: #000b5d;
      }

      .product-info {
        padding: 0.66rem 1.2rem;
        margin-top: 1.33rem;
        background: #f2f4fb;
        border-radius: 0.33rem;

        .info {
          display: flex;
          align-items: center;
          font-size: 1.2rem;
          padding: 0.8rem 0;

          .info-title {
            color: #999;
            flex-shrink: 0;
            width: 6rem;
          }

          .info-name {
            flex: 1;
            font-size: 1.3rem;
            line-height: 1.5rem;
          }
        }
      }

      .product-type {
        padding: 1.66rem 0 0 0.66rem;

        .type {
          overflow: hidden;
          margin-bottom: 1rem;
          line-height: 1.6rem;

          .label {
            float: left;
            margin-right: 0.79rem;
          }

          .type-list {
            float: left;

            li {
              margin-bottom: 0.58rem;
              font-size: 1.3rem;
              line-height: 1.6rem;
            }

            .gray {
              margin: 0 0.625rem;
              color: #999;
            }
          }
        }
      }

      .characteristic {
        padding: 0.66rem;
        background: #f2f4fb;
        border-radius: 0.33rem;
        margin-bottom: 1.5rem;

        .characteristic-title {
          color: #999;
        }

        .text {
          padding-top: 0.66rem;
          font-size: 1.3rem;
          line-height: 2.3rem;
          word-break: break-all;
        }
      }

      .parameter {
        padding: 0.66rem 0 0.41rem 0.66rem;

        .parameter-item {
          display: inline-block;

          .label {
            margin-right: 0.41rem;
            color: #999;
          }

          .text {
            margin-right: 0.75rem;
          }
        }
      }

      .documents {
        padding: 1.5rem 0 0 0.66rem;

        .item {
          display: flex;
          align-items: center;
          margin-bottom: 1.33rem;

          .documents-img {
            width: 1.58rem;
            height: 1.66rem;
            display: inline-block;
            margin-right: 0.625rem;
            vertical-align: text-bottom;
          }

          .documents-info {
            display: inline-block;
            color: #666;
            flex: 1 1;
            min-width: 20%;

            .name {
              color: #597eff;
              line-height: 1.3rem;
            }
          }
        }
      }

      .base-list {
        padding: 1.06rem 0 0 0.66rem;

        li {
          display: inline-block;
          margin: 0 1.5rem 0.8rem 0;
          overflow: hidden;

          .label {
            color: #999;
            margin-right: 0.42rem;
            float: left;
          }

          .text {
            margin-right: 1rem;
            font-size: 1.2rem;
          }
        }
      }

      .industry-list {
        overflow: hidden;
        padding-top: 1.2rem;

        li {
          float: left;
          width: 23.5%;
          padding: 1rem 2%;
          text-align: center;
          position: relative;
          margin-right: 2%;
          box-sizing: border-box;
          background: #f2f4fb;
          border-radius: 0.5rem;
          margin-bottom: 1rem;

          &:nth-child(4n) {
            margin-right: 0;
          }

          p {
            font-size: 1.4rem;
            overflow: hidden;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          b {
            font-size: 1.2rem;
            line-height: 2.4rem;
            color: #3f89f7;
            overflow: hidden;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: normal;
          }

          span {
            font-size: 1.2rem;
            overflow: hidden;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: normal;
          }
        }

        .green {
          color: #67b246;
        }

        .red {
          color: #eb3323;
        }
      }

      .formula-table {
        padding-top: 1.16rem;

        .thead {
          padding: 0;
          background: #f2f4fb;
          border-radius: 0.5rem;
        }

        .tbody {
          .tr {
            border-bottom: 0.08rem dashed #cbcbcb;

            &:last-child {
              border-bottom: 0;
            }
          }
        }

        .tr {
          display: flex;
          text-align: center;
          padding: 5px 0;

          .th {
            flex: 1 1;
            padding: 0 0.5rem;
            min-height: 2rem;
            line-height: 2rem;
            color: #999;

            &:first-child,
            &:last-child {
              width: 30%;
            }
          }

          .td {
            flex: 1 1;
            padding: 0 0.5rem;
            line-height: 3.2rem;
            word-break: break-all;

            &:first-child,
            &:last-child {
              width: 20%;
            }
          }
        }
      }
    }

    .more-btn {
      display: block;
      width: 17.4rem;
      height: 3.45rem;
      margin: 2rem auto 0 auto;
      background-color: #fff;
      text-align: center;
      border-radius: 2rem;
      line-height: 3.45rem;
      margin-bottom: 3.3rem;
      color: #0c2870;
      font-size: 1.3rem;

      img {
        display: block;
        width: 100%;
      }
    }

    .tab-box {
      .supply-warrper {
        .supply-item {
          display: flex;
          align-items: center;
          padding: 0.5rem 0.5rem 0.5rem 2rem;
          margin-bottom: 1.5rem;

          .supply-title {
            padding: 0.8rem 1.5rem 0 0;
            font-size: 1.5rem;
            font-weight: 900;
            line-height: 1.9rem;
          }

          .supply-left {
            flex: 1 1;
            width: 20%;

            .supply-info {
              display: inline-block;
              overflow: hidden;
              padding-top: 1.2rem;
            }

            .supply-label {
              float: left;
              margin: 0 0.33rem 0 0;
              color: #999;
              font-size: 1.2rem;
              line-height: 1.8rem;
            }

            .blue {
              color: #4e75ff;
              font-weight: bold;
            }

            .blod {
              font-weight: bold;
            }

            .supply-text {
              float: left;
              margin: 0 1.5rem 0 0;
              font-size: 1.5rem;
              line-height: 1.9rem;

              .price {
                font-size: 1.3rem;
                font-style: normal;
              }
            }
          }

          .supply-btn {
            width: 5.25rem;
            height: 5.6rem;
            border: 0;
            background: #f0f2f7;
            font-size: 1.3rem;
            color: #a0a7be;
            font-weight: bold;
            border-radius: 0.6rem;
          }
        }
      }

      .recommend-expert {
        display: flex;
        flex-wrap: wrap;
        padding-top: 1.58rem;

        .expert-item {
          width: 33%;
          text-align: center;
          margin-bottom: 1.5rem;

          .cover {
            width: 5.16rem;
            height: 5.16rem;
            border: 0.25rem solid #f2f4fb;
            border-radius: 50%;
            overflow: hidden;
          }

          .name {
            padding-top: 0.75rem;
            font-size: 1.6rem;

            img {
              display: inline-block;
              vertical-align: bottom;
              width: 1.4rem;
              height: 1.4rem;
              margin-bottom: 0.1rem;
            }
          }

          .type {
            padding-top: 0.66rem;
            color: #999;
          }
        }
      }

      .interact {
        .interact-list {
          padding: 1.33rem 0;
          border-bottom: 0.08rem solid #efefef;

          .interact-item {
            margin-bottom: 1.5rem;

            &:last-child {
              margin-bottom: 0;
            }

            .user {
              overflow: hidden;
              padding-left: 0.66rem;

              .user-info {
                .cover {
                  float: left;
                  width: 2.66rem;
                  height: 2.66rem;
                  margin-right: 0.66rem;
                }

                .base {
                  float: left;
                }

                .name {
                  padding-top: 0.2rem;
                  font-weight: 600;

                  &.expert {
                    color: #164aff;
                  }
                }

                .time {
                  padding-top: 0.2rem;
                  color: #666;
                }
              }

              .reply-btn {
                float: right;

                .icon {
                  width: 0.83rem;
                  height: 0.71rem;
                  display: inline-block;
                  margin: 1.51rem 0.41rem 0 0;
                  background: url("../../assets/images/message.png") no-repeat scroll top/cover;
                }

                .reply-text {
                  color: #164aff;
                }
              }
            }

            .interact-warrper {
              overflow: hidden;
              padding: 1.04rem 0 0 0.66rem;

              .interact-text {
                color: #666;
                line-height: 1.6rem;
                word-break: break-all;
              }

              .show-btn {
                float: right;
                padding: 0 0.8rem 0 1.6rem;
                line-height: 1.6rem;
                font-weight: bold;
              }
            }

            .other-reply {
              padding: 1.25rem 0;
              margin-top: 1.66rem;
              background: #f6f7fa;

              .get-more {
                padding-top: 0;
              }
            }
          }
        }

        .get-more {
          padding-top: 1.75rem;
          text-align: center;
          font-size: 1.3rem;
          line-height: 1.3rem;

          .more-icon {
            width: 0.58rem;
            height: 1.16rem;
            display: inline-block;
            margin-left: 0.5rem;
            background: url("../../assets/images/more_icon.png") no-repeat scroll top/cover;
            vertical-align: text-bottom;
          }
        }
      }

      .recommed-list {
        overflow: hidden;

        .recommed-warrper {
          width: 50%;
          float: left;

          .recommend-item {
            padding: 1.33rem 1rem 1.16rem;
            height: 9.2rem;

            &:nth-of-type(2n) {
              background: #f6f7fa;
            }

            .recommend-title-warrper {
              height: 4.16rem;
              margin-bottom: 1rem;
            }

            .recommend-title {
              padding: 0 0 0 0.83rem;
              word-break: break-all;
              font-size: 1.3rem;
              font-weight: bold;
              line-height: 2.2rem;
              border-left: 0.16rem solid #5178ff;
            }

            .recommend-text {
              padding: 0 0 0.5rem 0.83rem;
              color: #999;
            }
          }
        }
      }

      .classroom-list {
        .item {
          border-radius: 1.2rem;
          overflow: hidden;
          margin-bottom: 2.65rem;
          background: #fff;
          box-shadow: 2px 2px 6px #ededed;

          a {
            display: block;
          }

          .cover {
            width: 100%;
            display: block;
          }

          .calss-title {
            padding: 1.5rem 1.5rem 0;
            font-size: 1.6rem;
            line-height: 2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            font-weight: 600;
          }

          .teacher {
            padding: 1.2rem 1.5rem 1.5rem;
            font-size: 1.4rem;
            line-height: 1.8rem;
            color: #999;
          }
        }
      }

      .proinfo-list {
        margin-bottom: 2.5rem;

        .loading-text {
          padding: 1.7rem 0 3.45rem;
          font-size: 1.2rem;
          line-height: 1.4rem;
          color: #666;
          text-align: center;
        }

        li {
          overflow: hidden;
          font-size: 1.3rem;
          line-height: 2.8rem;
          padding: 0.8rem 1rem;
          background: #fff;
          box-shadow: 2px 3px 10px #ededed;
          margin-bottom: 1.5rem;
          border-radius: 1.2rem;
          position: relative;

          span {
            float: right;
            color: #999;
          }

          a.lis {
            width: 72%;
            float: left;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            overflow: hidden;
          }

          .imgs {
            width: 30%;
            float: left;
            margin-right: 4%;

            img {
              width: auto;
              max-width: 100%;
              display: block;
              border-radius: 1.2rem;
            }
          }
        }

        .img {
          padding: 0 1rem 0 0;

          .liss {
            width: 65%;
            float: right;
            display: block;
            line-height: 2.2rem;
            max-height: 4.4rem;
            margin-top: 0.6rem;
            overflow: hidden;
            word-break: break-all;
          }

          span {
            line-height: 2rem;
            position: absolute;
            bottom: 0.8rem;
            right: 1rem;
            color: #999;
          }
        }
      }
    }

    .recommed-more-btn {
      width: 12.33rem;
      height: 2.5rem;
      margin-bottom: 2.08rem;
      border: 0;
      border-radius: 1.8rem;
      background: #fff;
      color: #344780;
      font-size: 1.3rem;
      box-shadow: 0 6px 18px #dfdfdf;
    }
  }

  .shop_logo {
    border-radius: 5px;
  }

  .product-desc {
    font-size: 1.2rem;
    color: #999;
    padding: 2rem 1rem 0;
    line-height: 2rem;
  }

  .icon-join {
    width: 2.8rem;
    height: 2.8rem;
    vertical-align: text-bottom;
  }

  .product-edit-btns {
    display: flex;
    align-items: center;
    padding: 0 1rem 2rem 1rem;

    p {
      display: flex;
      align-items: center;
      color: #999;
      font-size: 1.4rem;
      margin-left: 2rem;

      &:first-child {
        margin-left: 0;
      }

      img {
        display: block;
        width: 1.8rem;
        margin-right: 0.5rem;
      }
    }
  }

  .product-video {
    width: 100%;
    margin: 1.33rem 0;
    border-radius: 12px;
    overflow: hidden;

    video {
      height: 20rem;
    }

    img {
      display: block;
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/home/product_details.vue